interface Props {
  answered: number;
  total: number;
  ready: boolean;
}

const AssessmentProgress = ({ answered, total, ready }: Props) => {
  const pct = total > 0 ? (answered / total) * 100 : 0;
  const allComplete = total > 0 && answered >= total;
  return (
    <div className="d-flex flex-column justify-content-center" style={{ minWidth: "180px" }}>
      <div className="d-flex justify-content-between align-items-center fs-11 mb-1">
        <span
          className={"text-uppercase fw-semibold text-nowrap " + (ready ? "text-success" : "text-light")}
          style={{ letterSpacing: "0.5px" }}
        >
          {allComplete
            ? "✓ All complete"
            : ready
            ? "✓ Required complete"
            : "Answered"}
        </span>
        <span className="text-light ms-2 text-nowrap">
          {answered} / {total}
        </span>
      </div>
      <div
        className="rounded-pill"
        style={{ height: "6px", backgroundColor: "#e9ecef", overflow: "hidden" }}
      >
        <div
          className="rounded-pill"
          style={{
            height: "100%",
            width: `${pct}%`,
            backgroundColor: ready ? "var(--bs-success)" : "#337e89",
            transition: "width 200ms ease",
          }}
        />
      </div>
    </div>
  );
};

export default AssessmentProgress;
